import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormDialogComponent } from 'src/app/components/form-dialog/form-dialog.component';
import { IFormDialogConfig } from 'src/app/shared/interfaces/IFormDialog';

@Injectable({ providedIn: 'root' })
export class FormDialogService {
  constructor(private readonly dialog: MatDialog) {}

  open<TResult>(config: IFormDialogConfig<TResult>): MatDialogRef<FormDialogComponent, TResult | undefined> {
    return this.dialog.open<FormDialogComponent, IFormDialogConfig<TResult>, TResult>(FormDialogComponent, {
      data: config,
      panelClass: 'side-panel-dialog',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true
    });
  }
}
